import { render, staticRenderFns } from "./alert-dialog.vue?vue&type=template&id=06982f3b&"
import script from "./alert-dialog.vue?vue&type=script&lang=js&"
export * from "./alert-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports